module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_6_4.cd2e9b61.jpeg";